export default __webpack_public_path__ + "static/media/drawing-card-bg.1ee6bf5f.svg";